document.addEventListener('click', function (event) {
  var summary = event.target.closest('[data-animate-accordion] > details > summary');
  if (!summary) return;

  var details = summary.parentElement;
  var content = summary.nextElementSibling;
  if (!content) return;

  event.preventDefault();

  var wrapper = details.closest('[data-animate-accordion]');
  var speed = 300;
  if (wrapper) {
    var cssSpeed = getComputedStyle(wrapper).getPropertyValue('--accordion-animation-speed');
    var parsed = parseFloat(cssSpeed);
    if (!isNaN(parsed)) speed = parsed;
  }

  if (details.dataset.animating === 'true') return;

  if (details.hasAttribute('open')) {
    animateClose(details, content, speed);
  } else {
    animateOpen(details, content, speed);
  }
});

function animateOpen(details, content, speed) {
  details.dataset.animating = 'true';
  details.setAttribute('open', '');
  var targetHeight = content.scrollHeight;

  content.style.overflow = 'hidden';
  content.style.height = '0px';
  content.offsetHeight;
  content.style.transition = 'height ' + speed + 'ms ease';
  content.style.height = targetHeight + 'px';

  var onEnd = function (e) {
    if (e.target !== content || e.propertyName !== 'height') return;
    content.style.removeProperty('height');
    content.style.removeProperty('overflow');
    content.style.removeProperty('transition');
    details.dataset.animating = 'false';
    content.removeEventListener('transitionend', onEnd);
  };
  content.addEventListener('transitionend', onEnd);

  if (speed === 0) onEnd({ target: content, propertyName: 'height' });
}

function animateClose(details, content, speed) {
  details.dataset.animating = 'true';
  var startHeight = content.scrollHeight;

  content.style.overflow = 'hidden';
  content.style.height = startHeight + 'px';
  content.offsetHeight;
  content.style.transition = 'height ' + speed + 'ms ease';
  content.style.height = '0px';

  var onEnd = function (e) {
    if (e.target !== content || e.propertyName !== 'height') return;
    details.removeAttribute('open');
    content.style.removeProperty('height');
    content.style.removeProperty('overflow');
    content.style.removeProperty('transition');
    details.dataset.animating = 'false';
    content.removeEventListener('transitionend', onEnd);
  };
  content.addEventListener('transitionend', onEnd);

  if (speed === 0) onEnd({ target: content, propertyName: 'height' });
}
